import * as React from 'react';

// components
import ItemsDisplayPage from '../../modules/pyc-redeem/items-display-page';
import BaseScreen from '../../modules/base-screen';

interface IItemsDisplayPageScreenProps {}

const ItemsDisplayPageScreen: React.SFC<IItemsDisplayPageScreenProps> = () => {
    return (
        <BaseScreen>
            <ItemsDisplayPage />
        </BaseScreen>
    );
};

export default ItemsDisplayPageScreen;
